import { render, staticRenderFns } from "./PreorderArticle.vue?vue&type=template&id=53007829&scoped=true&lang=pug&"
import script from "./PreorderArticle.vue?vue&type=script&lang=js&"
export * from "./PreorderArticle.vue?vue&type=script&lang=js&"
import style0 from "./PreorderArticle.vue?vue&type=style&index=0&id=53007829&lang=sass&nolang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53007829",
  null
  
)

export default component.exports